<template>
    <Dialog :open="open" :title="$t('selectSubscription')" @close="logout">
        <v-text-field
                v-model="search"
                :label="$t('search')"
                append-icon="mdi-magnify"
                clearable
                dense
                hide-details
                outlined
                @clear="search = ''"
        ></v-text-field>
        <div class="mt-5 font-weight-bold body-1">
            {{ $t('subscriptions') }}:
        </div>
        <v-list ref="oem" class="organizations pr-3" dense>
            <v-list-item-group
                    v-model="selectedOrganization"

                    color="primary">
                <v-list-item
                        v-for="(item, i) in filteredOrganizations"
                        :key="i"
                        :value="item.OrganizationID"
                        active-class="accent accentText--text pr-0"
                        class="rounded">
                    <template v-slot="{active}">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.Name"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon v-if="active">
                            <v-icon x-small>mdi-check-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>
            </v-list-item-group>
            <v-row class="mt-2">
                <v-col md="6">
                    <v-btn
                            :disabled="!selectedOrganization"
                            block
                            class="text-h6 py-6 accentText--text"
                            color="accent"
                            large
                            @click="selectOrganization">
                        {{ $t('select') }}
                    </v-btn>
                </v-col>
                <v-col md="6">
                    <v-btn
                            block
                            class="text-h6 py-6 shadow"
                            color="secondary primary--text"
                            large
                            @click="logout">
                        {{ $t('cancel') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-list>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "OrganizationSelector",
  created() {
    if (this.isLoggedIn) {
      this.getMyOrganizations(!this.$store.getters.getOrganizationId);
    }
  },
  components: {Dialog},
  data() {
    return {
      open: false,
      organizations: [],
      selectedOrganization: null,
      search: '',
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    filteredOrganizations() {
      if (this.search) {
        return this.organizations.filter(organization => organization.Name.toLowerCase().includes(this.search.toLowerCase()));
      } else {
        return this.organizations;
      }
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    },
    getOrganizationUpdate() {
      return this.$store.getters.getOrganizationUpdate;
    }
  },
  watch: {
    isLoggedIn(val) {
      if (val) {
        this.getMyOrganizations();
      }
    },
    organizationID(val) {
      if (!val) {
        this.getMyOrganizations();
      }
    },
    getOrganizationUpdate() {
      this.getMyOrganizations();
    }
  },
  methods: {
    getMyOrganizations(showWindow = true) {
      const url = this.$store.getters.getUrl('organizations');
      this.axios.get(url).then(({data}) => {
        this.organizations = data.Result.filter(organization => !organization.IsSubscriptionExpired);
        if (!this.organizations.length) {
          this.$store.dispatch('setOrganizationId', null);
          this.$router.push({name: 'subscriptionExpired'});
        }
        this.$store.dispatch('setOrganizations', data.Result);
        const selectedWasRemoved = !data.Result.filter(organization => organization.OrganizationID === this.$store.getters.getOrganizationId).length
        if (showWindow || selectedWasRemoved) {
          if (this.organizations.length === 1) {
            this.$store.dispatch('setOrganizationId', this.organizations[0].OrganizationID);
          } else if (this.organizations.length > 0 && (!this.$store.getters.getOrganizationId || selectedWasRemoved)) {
            this.open = true;
          }
        }
      });
    },
    logout() {
      this.open = false
      this.$store.dispatch('logout');
      this.$router.push({name: 'login'});
    },
    selectOrganization() {
      if (!this.selectedOrganization) {
        return;
      }
      this.search = '';
      this.$store.dispatch('setOrganizationId', this.selectedOrganization).then(() => {
        if (this.$route.name !== 'myAccount') {
          this.$router.push({name: 'circleMap'});
        }
      });
      this.open = false;
    }
  }
};
</script>

<style scoped>

</style>